import React from "react";
import { motion } from "framer-motion";
import { useDroppable } from "@dnd-kit/core";

/**
 * A droppable zone. Children render inside. When a DraggableCard is dropped
 * here, onDragEnd will fire with the drop target's id.
 *
 * Props:
 * - id: unique drop zone id
 * - data: arbitrary data to pass to onDragEnd
 * - motionProps: when given, the zone is a framer-motion element (the table's groups glide to their new place)
 * - anything else (data-* attributes) goes on the element
 */
export const DropZone = ({ id, data, children, className = "", activeClassName = "", testId, style, onClick, motionProps, ...rest }) => {
  const { isOver, setNodeRef } = useDroppable({ id, data });
  const Tag = motionProps ? motion.div : "div";
  return (
    <Tag
      ref={setNodeRef}
      className={`${className} ${isOver ? activeClassName : ""} ${motionProps ? "" : "transition-colors"}`}
      style={style}
      data-testid={testId}
      onClick={onClick}
      {...motionProps}
      {...rest}
    >
      {children}
    </Tag>
  );
};

export default DropZone;
